import i18n from "i18next";
import Backend from 'i18next-http-backend';
import { initReactI18next } from "react-i18next";
import { getLocaleFromPath } from "./localePath";

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // The URL decides the language: "/tc/..." is Chinese, everything else English.
    lng: getLocaleFromPath(window.location.pathname),
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;
